import { cssTransition } from "react-toastify";

import { type NotificationResponse } from "@vega-api/generated/types/notificationResponse";
import { CloseButton } from "@vega-core/components/Buttons/CloseButton/CloseButton";

import { getNotificationIcon } from "./getNotificationIcon";

export const NOTIFICATION_TOAST_DURATION_MS = 5000;

export const NotificationToastTransition = cssTransition({
  enter: "vc-notification-toast-slide-in-up",
  exit: "vc-notification-toast-slide-out-down",
  collapse: false,
});

type Props = {
  notification: NotificationResponse;
  onClick?: () => void;
  closeToast?: () => void;
};

export const NotificationToast = ({
  notification,
  onClick,
  closeToast,
}: Props) => {
  const icon = getNotificationIcon(notification.type);

  return (
    <div className="flex items-start gap-3 pr-2">
      <button
        className="flex-1 min-w-0 flex items-start gap-3 text-left outline-none focus-visible:underline"
        onClick={onClick}
        type="button"
      >
        {icon ? (
          <span
            aria-hidden="true"
            className="shrink-0 inline-flex items-center justify-center h-8 w-8 rounded-default bg-background/tertiary text-text/secondary"
          >
            {icon}
          </span>
        ) : null}
        <div className="flex-1 min-w-0 flex flex-col">
          <p className="body-small-semibold text-text/primary">
            {notification.title}
          </p>
          {notification.body ? (
            <p className="body-extra-small-regular text-text/secondary line-clamp-3">
              {notification.body}
            </p>
          ) : null}
        </div>
      </button>
      {closeToast ? (
        <div className="shrink-0">
          <CloseButton onClick={closeToast} />
        </div>
      ) : null}
    </div>
  );
};
